/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Review_Errors_OptionInputs */



/**
* | output |
* | --- |
* | "Review Errors" |
*
* @param {Error_Nav_Review_Errors_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_review_errors_option = /** @type {((inputs?: Error_Nav_Review_Errors_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Review_Errors_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreurs de revision")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler überprüfen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errori di revisione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибки проверки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Errores de revisión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("审查错误")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エラーを確認する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समीक्षा त्रुटियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erros de revisão")
	return /** @type {LocalizedString} */ ("Review Errors")
});